import React, { FC } from 'react';
import { ChangeServiceCard } from '../ChangeServiceCard';
import { ChangeServiceTypes } from '../../../models/Accounts';
import { ServiceCardSkeleton } from '../../commons/ServiceCardSkeleton';

interface ChangeServiceCardList {
  availableServices: ChangeServiceTypes[];
  handleChange: (id: string | number, isDaily: boolean, isCurrent: boolean) => void;
  handleCallback: (serviceName: string, serviceAnalyticsName: string) => void;
  canChange: boolean;
  canActivate: boolean;
}

export const ChangeServiceCardList: FC<ChangeServiceCardList> = ({
  handleCallback,
  availableServices,
  handleChange,
  canChange,
  canActivate,
}) => {
  return (
    <div className="tab-panel">
      <div className="tab-panel__tabs-container">
        {availableServices.length ? (
          availableServices[0].Services.map((service) => {
            return (
              <ChangeServiceCard
                isAvailableForConnection={service.isAvailableForConnection}
                isDaily={service.Daily}
                description={service.Description}
                name={service.Name}
                canChange={canChange}
                canActivate={canActivate}
                price={service.Price}
                key={service.id}
                iconType={service.icon}
                isCurrent={service.isCurrent}
                isPrepaid={service.isPrepaid}
                isCashback={service.isCashback}
                handleChange={handleChange}
                serviceId={service.id}
                handleCallback={handleCallback}
                serviceAnalyticsName={service.AnalyticsID ?? service.Name}
              />
            );
          })
        ) : (
          <>
            <ServiceCardSkeleton canManage={false} />
            <ServiceCardSkeleton canManage={false} />
          </>
        )}
      </div>
    </div>
  );
};
